import { Icon } from '@oliasoft-open-source/react-ui-library';
import { NotesTabContent } from './notes-tab-content';

export const getNotesTab = (currentModule: string) => ({
  icon: <Icon icon="note" />,
  content: <NotesTabContent currentModule={currentModule} />,
});
